import {Component, OnDestroy, OnInit} from '@angular/core';
import {Project} from "@catcore/types/api-v2";
import {NotificationsService, ProjectService} from "@catcore/services";
import {isNullOrUndefined} from "util";
import {Subscription} from "rxjs";
import {ServerNotificationService} from "@catcore/services/server-notification.service";

@Component({
  selector: 'catapp-evid-debug',
  templateUrl: './evid-debug.component.html',
  styleUrls: ['./evid-debug.component.scss']
})
export class EvidDebugComponent implements OnInit,OnDestroy {

  private project: Project;
  subscription: Subscription = null;

  constructor(private projectService: ProjectService,
              private notificationService: NotificationsService,
              private serverNotificationService: ServerNotificationService) { }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((currentProject: Project) => {
        const isActiveProject = !isNullOrUndefined(currentProject) && !isNullOrUndefined(currentProject.id);
        if (isActiveProject) {
          this.project = currentProject;
        } else {
          this.project = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  generateEvidFunctions() {
    const subscr = this.projectService
      .createConfigs(this.project, null, 'EVID', false)
      .finally(() => subscr.unsubscribe())
      .subscribe((result) => {
        this.serverNotificationService.signalProcessAboutToStart();
      });
  }

  updateToCatEvid() {
    const subscr = this.projectService
      .g7kUpdateToCatEvid(this.project)
      .finally(() => subscr.unsubscribe())
      .subscribe((result) => {
        this.notificationService.success('Project updated', result.updateCount + ' ggw device params of project ' + this.project.name + ' have been updated to use CAT evids.');
        console.log(result);
      });
  }

  downgradeToManualEvid() {
    const subscr = this.projectService
      .g7kDowngradeToManualEvid(this.project)
      .finally(() => subscr.unsubscribe())
      .subscribe((result) => {
        this.notificationService.success('Project downgraded', result.updateCount + ' ggw device params of project ' + this.project.name + ' have been updated to use manual evids. Please note that this has to be repeated if the project features are updated.');
        console.log(result);
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/evid-functions/components/evid-debug/evid-debug.component.ts